/* Happy Little Doers — PDP cross-sell (bundle slot) + accessories safeguard.
   Vanilla ES6+, no dependencies. Loaded from sections/hld-atf.liquid only.

     1. <hld-bundle-slot> — the sticker that flies from beside the "with the bundle" link
        onto the bundle row's tag slot when the row unfolds (snippets/hld-bundle-slot.liquid).

     2. Swap-not-add safeguard — <hld-quick-add> (hld-theme.js) posts every ticked accessory
        ALONGSIDE the main product. If a ticked row is a bundle that contains this pack
        (marked data-hld-swap by hld-upsell-picks.liquid), the bundle must REPLACE the pack,
        never join it — otherwise the shopper pays for the pack twice. With the 10 Sep sheet
        no bundle sits in an accessory slot, so this is defence, not a code path in use. */
(function () {
  'use strict';

  /* ---- 1. <hld-bundle-slot> ------------------------------------------------ */
  if (!customElements.get('hld-bundle-slot')) {
    customElements.define('hld-bundle-slot', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-hld-bslot-toggle]');
        this.stk = this.querySelector('[data-hld-bslot-sticker]');
        this.home = this.querySelector('[data-hld-bslot-home]');
        this.land = this.querySelector('[data-hld-bslot-land]');
        this.pan = this.querySelector('[data-hld-bslot-panel]');
        if (!this.btn || !this.stk || !this.home || !this.land || !this.pan) return;

        this.btn.addEventListener('click', () => this.toggle());
        this.stk.addEventListener('click', () => this.toggle());

        /* Park at home, and re-park whenever layout can have moved: resize, fonts
           landing, the page finishing its load. Position is measured, not guessed. */
        this.repark = () => this.park();
        window.addEventListener('resize', this.repark);
        window.addEventListener('load', this.repark);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.repark);
        this.park();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.repark);
        window.removeEventListener('load', this.repark);
      }

      get isOpen() { return this.classList.contains('is-open'); }

      /* Move the sticker's top-left onto `el`'s top-left, relative to this element. */
      place(el, landed) {
        const r = el.getBoundingClientRect();
        const x = this.getBoundingClientRect();
        this.stk.style.transform = 'translate(' + (r.left - x.left) + 'px,' + (r.top - x.top) + 'px)';
        this.stk.classList.toggle('is-landed', landed);
      }

      /* Snap (no transition) to wherever the sticker should currently be. */
      park() {
        const open = this.isOpen;
        this.stk.style.transition = 'none';
        this.place(open ? this.land : this.home, open);
        void this.stk.offsetWidth; // flush so the next transform animates again
        this.stk.style.transition = '';
      }

      toggle(force) {
        const open = typeof force === 'boolean' ? force : !this.isOpen;
        this.classList.toggle('is-open', open);
        this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.stk.classList.remove('is-home');

        if (open) {
          /* Wait for the panel to reach full height, then measure the landing spot —
             measuring early lands the sticker where the row WAS, mid-animation. */
          let fired = false;
          const done = (e) => {
            if (e && (e.target !== this.pan || e.propertyName !== 'grid-template-rows')) return;
            if (fired) return;
            fired = true;
            this.pan.removeEventListener('transitionend', done);
            if (this.isOpen) this.place(this.land, true);
          };
          this.pan.addEventListener('transitionend', done);
          setTimeout(done, 420); // reduced-motion / no transitionend fallback
        } else {
          this.place(this.home, false);
          setTimeout(() => { if (!this.isOpen) this.stk.classList.add('is-home'); }, 500);
        }
      }
    });
  }

  /* ---- 2. Swap-not-add safeguard -------------------------------------------- */
  if (!window.__hldSwapGuard) {
    window.__hldSwapGuard = true;

    /* Capture phase, so this runs BEFORE <hld-quick-add>'s own submit handler, which
       reads the form's `id` input and the ticked boxes synchronously. We point the form
       at the bundle's variant, untick the bundle so it isn't ALSO posted as an add-on,
       and put the original id back once the handler has read it. */
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || !form.closest) return;
      const host = form.closest('hld-quick-add');
      if (!host || !host.closest('.hld-atf__purchase')) return;

      const swap = [...host.querySelectorAll('[data-hld-upsell-check][data-hld-swap]')].find((c) => c.checked);
      if (!swap) return;
      const idInput = form.querySelector('input[name="id"]');
      const bundleVariant = swap.getAttribute('data-hld-swap');
      if (!idInput || !bundleVariant) return;

      const original = idInput.value;
      idInput.value = bundleVariant;
      swap.checked = false;
      swap.dispatchEvent(new Event('change', { bubbles: true })); // lets the running total re-sync
      setTimeout(() => { idInput.value = original; }, 0);
    }, true);
  }
})();
